import {DiamondNode, DiamondNodeModel} from "@logicflow/core";

// 自定义的条件分支
class CustomerDiamondNode extends DiamondNode{

}
class CustomerDiamondNodeModel extends DiamondNodeModel{
    getNodeStyle() {
        const style = super.getNodeStyle();
        // 如果关联关系有问题，那么将线显示为红色
        let properties = this.properties;
        if (properties.invalid) {
            style.stroke = "var(--el-color-danger)";
        }
        return style;
    }
}
export default {
    model: CustomerDiamondNodeModel,
    view: CustomerDiamondNode,
    type: "CustomerDiamondNode"
}